{
  "main": {
    "title": "Masa in težišče",
    "nazaj": "Nazaj"
  },
  "labelswb": {
    "isci": "Poišči / izberi letalo",
    "izberi": "izberi",
    "odstrani": "odstrani",
    "izbrano": "izbrano",
    "neObstaja": "iskanega plovila ni med plovili",
    "praznaLista": "ni plovil za prikaz"
  },
  "tekstwb": {
    "opozorilo": "Letalo {plovilo} nima nastavljenih parametrov za W&B!",
    "opozorilo_podrobno": " Sporočite upravitelju registracijo plovila, da doda potrebne parametre."
  },
  "grafwb": {
    "opozorilo": "Letalo {plovilo} nima nastavljenih parametrov wgt1-5 za prikaz grafa W&B!",
    "opozorilo_podrobno": " Sporočite upravitelju registracijo plovila, da doda potrebne parametre."
  },
  "obrazec": {
    "labels": {
      "tezaLetalo": "Teža (praznega) letala",
      "izpisTeze": "Teža ",
      "izpisMomenta": "Moment",
      "pilot": "Pilot in prednji sedež",
      "sopotniki": "Sopotniki",
      "gorivo": "Gorivo",
      "ptrljaga": "Prtljaga",
      "sTeza": "Skupna teža",
      "sMoment": "Skupaj moment",
      "sMasa": "Skupna masa",
      "maksimalno": "Maksimalno:",
      "kalkulacija": "Kalkulacija"
    }
  }
}